var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 7,
  viewBox: "0 0 11 7"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M10.172.163a.42.42 0 0 0-.588 0L3.701 6.008l-2.587-2.55a.42.42 0 0 0-.588 0 .41.41 0 0 0 0 .582l2.882 2.84c.16.16.428.16.589 0L10.172.747a.41.41 0 0 0 0-.583c-.162-.16.163.161 0 0"
})));
export default SvgCheckWhite;